import paymentSettingHandler from "../../services/PaymentSettings";

export default {
    async loadPaymentSettings({commit, dispatch}, payload) {
        const {data} = await paymentSettingHandler.all(payload);

        commit('SET_PAYMENTS_SETTINGS', data);
    },
    async updatePaymentSettings({commit, dispatch}, payload) {
        return paymentSettingHandler.update(payload);
    },
    async sortedPaymentSettings({commit, dispatch}, payload) {
        return paymentSettingHandler.sorted(payload);
    }
}
